<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.yjm" alt style="line-height:1.5;">
        <br>
      </p>
      <p style="white-space:normal;">
        <br>
      </p>
      <p></p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">
              <span style="font-family:Arial;">Metallugical coal</span>
              <br>
            </span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-family:Arial;">Specification</span>
          <br>
        </span>
      </p>
      <p></p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  TYPE
                  A (medium ash)
                </span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  TYPE
                  B (low ash)
                </span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Moisture</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4.4%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Ash</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  3%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  1.5%
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Ti02</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .25
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .1
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Al2O3
                  (in coal)
                </span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .6
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .5
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  DFC
                  (dry fixed carbon)
                </span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  54%
                  min
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">57%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Fe203</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .3
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .27%
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">CaO</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .3
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  .3
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Dry
                  S
                </span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  1.2%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1.03%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Volatile</span>
                <span style="font-size:10.0pt;font-family:宋体;"></span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  43%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">41.5</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Caking index</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">94</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">97</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Plastic layer</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:10pt;font-family:Arial;">14.5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:10pt;font-family:Arial;">14</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        yjm: require("../../../assets/img/common/yjm.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/yjm.vue